// Webpack Imports
import * as bootstrap from 'bootstrap';


(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});
})();

/////
function ugCheckoutNipRerender() {
	const checkoutNip = document.getElementById('billing_nip_field');
	const checkoutBillingFieldsWrapper = document.querySelector('.woocommerce-billing-fields__field-wrapper');
	checkoutNip.style.display = 'block';
	checkoutBillingFieldsWrapper.appendChild(checkoutNip);
}

window.addEventListener('load', () => {
	if (!document.querySelector('.woocommerce-checkout')) {
		return;
	}
	const billingCompany = document.getElementById('billing_company');
	billingCompany.addEventListener('change', ugCheckoutNipRerender);
});

let stopGeneratingHtml = false;
setTimeout(() => {
	window.addEventListener('scroll', () => {
		if ((stopGeneratingHtml === true) || (!document.querySelector('.woocommerce-checkout'))) {
			return;
		}

		const contactText = '';
		const contact = document.createElement('li');
		const contactContainer = document.getElementById('shipping_method');
		contactContainer.appendChild(contact);
		contact.innerHTML = contactText;
		stopGeneratingHtml = true;
		setTimeout(6000, () => {
			if (!document.querySelector('#shipping_method > li:nth-child(3)')) {
				return;
			}
			stopGeneratingHtml = false;
		});
	}, { passive: true });
}, 3000);
